// repo/primary-care-connect/frontend/src/pages/Portal/ClinicAdmin/ClinicProfile/sections/OnSiteServicesSection.tsx

import React from "react";

type IdName = { id: number; name: string };

export default function OnSiteServicesSection(props: {
  editMode: boolean;
  onSiteServices: IdName[];
  onSiteServiceOptions: IdName[];
  draftOnSiteServiceIds: number[];
  setDraftOnSiteServiceIds: (ids: number[]) => void;
  savingOnSite: boolean;
  onSiteError: string | null;
  onSiteSavedAt: string | null;
  onSaveOnSiteServices: () => void;
  getSelectedIdsFromMultiSelect: (e: React.ChangeEvent<HTMLSelectElement>) => number[];
  formatDateTime: (val: string | null | undefined) => string;
}) {
  const {
    editMode,
    onSiteServices,
    onSiteServiceOptions,
    draftOnSiteServiceIds,
    setDraftOnSiteServiceIds,
    savingOnSite,
    onSiteError,
    onSiteSavedAt,
    onSaveOnSiteServices,
    getSelectedIdsFromMultiSelect,
    formatDateTime,
  } = props;

  const safeServices = Array.isArray(onSiteServices) ? onSiteServices : [];
  const safeOptions = Array.isArray(onSiteServiceOptions) ? onSiteServiceOptions : [];

  return (
    <details className="ca-clinic-profile__panel" open>
      <summary className="ca-clinic-profile__summary">
        <div>
          <div className="ca-clinic-profile__sectionTitle">On-site services</div>
          <div className="ca-clinic-profile__hint">Clinic admin-managed</div>
        </div>
      </summary>

      <div className="ca-clinic-profile__row">
        <div className="ca-clinic-profile__label">Services</div>
        <div className="ca-clinic-profile__value">
          {!editMode ? (
            <div className="ca-clinic-profile__chips">
              {safeServices.length ? (
                safeServices.map((x) => (
                  <span key={x.id} className="ca-clinic-profile__chip">
                    {x.name}
                  </span>
                ))
              ) : (
                <span style={{ color: "#6b7a94" }}>—</span>
              )}
            </div>
          ) : (
            <>
              <select
                className="ca-clinic-profile__multiselect"
                multiple
                value={draftOnSiteServiceIds.map(String)}
                disabled={savingOnSite}
                onChange={(e) =>
                  setDraftOnSiteServiceIds(getSelectedIdsFromMultiSelect(e))
                }
              >
                {safeOptions.map((opt) => (
                  <option key={opt.id} value={String(opt.id)}>
                    {opt.name}
                  </option>
                ))}
              </select>
              <div className="ca-clinic-profile__help">
                Tip: hold Ctrl (Windows) / Cmd (Mac) to select multiple.
              </div>
            </>
          )}
        </div>
      </div>

      {onSiteError ? (
        <div className="ca-clinic-profile__row">
          <div className="ca-clinic-profile__label"></div>
          <div className="ca-clinic-profile__value ca-clinic-profile__row-error">
            {onSiteError}
          </div>
        </div>
      ) : null}

      {editMode ? (
        <div className="ca-clinic-profile__row">
          <div className="ca-clinic-profile__label"></div>
          <div className="ca-clinic-profile__value ca-clinic-profile__save-row">
            <button
              className="ca-clinic-profile__btn"
              onClick={onSaveOnSiteServices}
              disabled={savingOnSite}
            >
              {savingOnSite ? "Saving…" : "Save On-site Services"}
            </button>

            {onSiteSavedAt ? (
              <span className="ca-clinic-profile__savedAt">
                Saved {formatDateTime(onSiteSavedAt)}
              </span>
            ) : null}
          </div>
        </div>
      ) : null}
    </details>
  );
}
